<template>
  <input class="c-form__input" type="text" name="sQuantity" id="sQuantity" value="1">
</template>

<script>
export default {
  name: 'Input'
}
</script>

<style scoped lang="sass">
  .c-form__input
    padding: 1em
    border-radius: $border-radius
    border: 1px solid $light-grey
    width: 100%
    outline: 0 none
    margin-bottom: $form-element-spacing
    box-sizing: border-box
    &:focus
      background-color: lighten($light-grey, 7%)
      border-color: darken($light-grey, 5%)

    .has--fluid-label &
      padding: 0
      border: 0
      margin-bottom: 0
      &:focus
        background-color: transparent
        border-color: transparent
</style>
